// extracted by mini-css-extract-plugin
export var whocontact = "oer-module--whocontact--3eGZy";
export var who = "oer-module--who--1GsMu";
export var resources = "oer-module--resources--aePEU";
export var cardholder = "oer-module--cardholder--3BMrl";